import { $LocalStorage } from '../../../NonReact/utils/StorageUtils'
import { hasQueryParam } from '../../../NonReact/utils/LocationUtils'

const DEVELOPMENT_MODE_KEY: string = 'developmentMode'

const isDevelopmentModeEnabled: boolean =
    hasQueryParam(DEVELOPMENT_MODE_KEY) || $LocalStorage.getItem(DEVELOPMENT_MODE_KEY) === true

/**
 * If development mode is enabled, logs the given arguments to console.debug.
 *
 * @param args - The arguments to log.
 */
export const $debug = (...args: unknown[]): void => {
    if (isDevelopmentModeEnabled) {
        const { debug }: Console = console

        debug(...args)
    }
}

export const $error = (...args: unknown[]): void => {
    const { error }: Console = console

    error(...args)
}
